import script from "./Play.vue?vue&type=script&setup=true&lang=js"
export * from "./Play.vue?vue&type=script&setup=true&lang=js"

import "./Play.vue?vue&type=style&index=0&id=413312db&lang=css"

const __exports__ = script;

export default __exports__